import { render } from "./match-center.vue?vue&type=template&id=50ecaee6"
import script from "./match-center.vue?vue&type=script&lang=js"
export * from "./match-center.vue?vue&type=script&lang=js"

import "./match-center.vue?vue&type=style&index=0&id=50ecaee6&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__